import { render, staticRenderFns } from "./CheckPostage.vue?vue&type=template&id=81df519e&scoped=true&"
import script from "./CheckPostage.vue?vue&type=script&lang=js&"
export * from "./CheckPostage.vue?vue&type=script&lang=js&"
import style0 from "./CheckPostage.vue?vue&type=style&index=0&id=81df519e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81df519e",
  null
  
)

export default component.exports